'use strict';

/**
 * Enum definition file for price tag layouts. Values are the client layout component names.
 *
 * @module data/enums/price-tag-layouts
 */
module.exports = {
    // Not named `default`: Vite's CommonJS interop would make that key the module's default export.
    fallback: 'price-tag-default',
    headlinePrice: 'price-tag-headline-price',
    percentOffPrice: 'price-tag-percent-off-price',
    percentOffPriceLowest: 'price-tag-percent-off-price-lowest',
    nthItemOff: 'price-tag-nth-item-off',
    spendThreshold: 'price-tag-spend-threshold',
    tieredPercent: 'price-tag-tiered-percent',
    buyNGetFree: 'price-tag-buy-n-get-free',
    wasNowSplit: 'price-tag-was-now-split',
    saveValueTwoGroups: 'price-tag-save-value-two-groups',
};
